/**
 * ECharts React 래퍼 — echarts-for-react의 core 컴포넌트에
 * 트리셰이킹된 echarts(core) 모듈을 주입한다.
 *
 * 사용법: `import EChart from "src/lib/EChart"` — 기존 ReactEcharts/ReactECharts와
 * props 동일 (option / style / theme / notMerge / lazyUpdate / opts / onEvents 등).
 * 절대 `echarts-for-react`를 직접 import하지 말 것 (풀 번들이 로드됨).
 */
import Core from "echarts-for-react/lib/core";
import type { EChartsReactProps } from "echarts-for-react/lib/types";
import { forwardRef } from "react";
import echarts from "src/lib/echarts";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EChartCore = Core as any;

interface EChartProps extends EChartsReactProps {
  /** 인스턴스 접근용 ref — useRef로 전달, getEchartsInstance()로 접근 */
  ref?: React.Ref<any>;
}

/**
 * echarts-for-react core는 ref를 소비하지 않고 내부 div에 자체 ref를 쓰므로,
 * forwardRef로 받은 ref에 "컴포넌트 인스턴스"를 전달해 기존 ReactECharts ref 동작(
 * ref.current.getEchartsInstance())을 그대로 유지한다.
 */
const EChartWrapper = forwardRef<any, EChartProps>((props, ref) => (
  <EChartCore
    ref={(inst: any) => {
      if (typeof ref === "function") ref(inst);
      else if (ref && typeof ref === "object") (ref as React.MutableRefObject<any>).current = inst;
    }}
    echarts={echarts}
    {...props}
  />
));

EChartWrapper.displayName = "EChart";

export default EChartWrapper;
export type { EChartsReactProps };

